let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iiDkX")).then(() => parcelRequire('jgLAY'));